import questions from "../../assets/js/helpMultilngual/bs_tw_questions";
import troubles from "../../assets/js/helpMultilngual/bs_en_troubles";
const tw = {
  language: "繁體中文",
  bstext: {
    bs1: "換電方案",
    bs2: "套餐詳情",
    bs3: "使用說明",
    bs4: "我要開通",
    bs5: "下一步",
    bs6: "確認變更",
    bs7: "方案變更",
    bs8: "換電方案",
    bs9: "變更成功",
    bs10: "開通成功",
    bs11:
      "請儘快在藍鯊服務門市進行啟動，即可使用換電功能。 啟動后如需取消，請至鄰近服務據點進行辦理。",
    bs12: "{msg}秒後返回",
    bs13: "歷史帳單",
    bs14: "待支付",
    bs15: "您目前暫無帳單資訊",
    bs16: "年",
    bs17: "{msg}月帳單",
    bs18: "{msg}月账单金額",
    bs19: "方案費用",
    bs20: "單電方案",
    bs21: "雙電方案",
    bs22: "換電費用",
    bs23: "本月付費換電量",
    bs24: "安時",
    bs25: "變更費用",
    bs26: "升級費用",
    bs27: "付款時間",
    bs28: "付款方式",
    bs29: "資費說明",
    bs30: "帳單費用 = 方案費用 + 換電費用 + 變更費用 ",
    bs31: "方案費用 = 月固定費用（不足一月按天折算）",
    bs32: "換電費用 = 週期內付費換電總安時 * 2元",
    bs33: "變更費用 = 使用超3個月升級費用",
    bs34: "去付款",
    bs35: "結算帳單",
    bs36: "暫無",
    bs37: "未結算帳單",
    bs38: "至今",
    bs39: "未出帳",
    bs40: "出帳日",
    bs41: "最終付款日",
    bs42: "為保證正常使用，請儘快付款",
    bs43: "您目前暫無帳單資訊",
    bs44: "我的帳單",
    bs45: "開通",
    bs46: "你尚未開通換電方案",
    bs47: "我的方案",
    bs48: "請選擇想要變更的方案",
    bs49: "開通時間",
    bs50: "啟用時間",
    bs51: "關閉時間",
    bs52: "變更時間",
    bs53: "取消方案",
    bs54:
      "您的原方案已使用超過3個月，如轉換需要繳納3000台幣的設定費，費用將統計至本月帳單，請確認後轉換。",
    bs55: "我再想想",
    bs56: "知道了，確認變更",
    bs57: "是否確認取消？",
    bs58: "取消",
    bs59: "確認",
    bs60: "我的方案",
    bs61: "你已取消{msg}方案",
    bs62:
      "您的原方案已使用超過3個月，如轉換需要繳納3000台幣的設定費，費用將統計至本月帳單。",
    bs63: "信息確認",
    bs64:
      "您申請變更為 {name}方案，將於次日生效，變更後本月帳單將按照兩個方案實際使用天數計算。 請確認！",
    bs65: "應結算金額",
    bs66: "請選擇付款條件",
    bs67: "付款",
    bs68: "錯誤碼：",
    bs69: "完成",
    bs70: "重新結算",
    bs71: "取消結算",
    bs72: "加載中",
    bs73: "付款成功",
    bs74: "付款失敗",
    bs75: "頁面跳轉中"
  },
  bsstatus: {
    // 结算周期
    cycles: [
      {
        key: 1,
        val: "月"
      }
    ],
    // 套餐状态
    menus: [
      {
        key: "1",
        val: "未啟動"
      },
      {
        key: "2",
        val: "使用中"
      },
      {
        key: "3",
        val: "已變更"
      },
      {
        key: "4",
        val: "已關閉"
      }
    ],
    // 支付方式
    payMethods: [
      {
        key: "CARD",
        val: "Credit Card"
      },
      {
        key: "BANK",
        val: "Bank Transfer"
      },
      {
        key: "VBANK",
        val: "Virtual Account"
      }
    ],
    // 支付状态
    payStatuss: [
      {
        key: "1",
        val: "待支付"
      },
      {
        key: "2",
        val: "已支付"
      },
      {
        key: "3",
        val: "已逾期"
      },
      {
        key: "4",
        val: "未結算"
      }
    ]
  },
  helpCenter: {
    documentTitle: "支援中心",
    title: [
      "綁定啟用",
      "帳號問題",
      "駕駛須知",
      "ADAS安全輔助",
      "娛樂資訊",
      "APP使用問題",
      "車輛升級",
      "用電安全",
      "車輛維護",
      "異常自檢"
    ],
    description: "Description:",
    solution: "Suggested Solution:",
    exAssistance: "換電幫助",
    exAssistanceList: [
      "關於藍鯊智能換電服務",
      "關於換電帳號",
      "關於換電套餐",
      "關於如何使用換電服務"
    ],
    exAssistanceSubtitle: [
      ["關於藍鯊智能換電服務"],
      ["如何獲得換電帳號？", "換電帳號有哪些用途？"],
      [
        "什麼是換電套餐？",
        "今個月剩餘額度可以轉到下個月使用嗎？",
        "購買後嘅換電套餐可以退款嗎？",
        "購買後嘅換電套餐可以續費嗎？",
        "換電套餐嘅生效日期規則係點？"
      ],
      [
        "購買完套餐後，首次換電要如何操作？",
        "點樣操作換電？",
        "點樣查詢各個換電櫃站點嘅電池資訊情況？",
        "導致換電失敗可能嘅原因有啥？"
      ]
    ],
    exAssistanceInfo: [
      [
        [
          "藍鯊智能換電服務，係藍鯊對特定需求市場提供嘅快捷補能服務，包括設置換電櫃、提供電池租賃服務、換電功能等，有效解決電動摩托車續航力不足嘅劣勢，最快3秒完成補能換電。",
          "由於各市場需求唔同，藍鯊智能換電服務唔完全涵蓋藍鯊車輛嘅銷售區域，部分銷售區域冇提供換電補能服務。具體情況，可查詢當地銷售門市或經銷商。"
        ]
      ],
      [
        [
          "如果您所在嘅地區開通咗藍鯊智能換電服務，首先您需要下載藍鯊App同成功註冊一個App帳號。喺App嘅首頁會搵到「換電服務」嘅功能卡片。",
          "揀選「換電服務」功能卡片，揀選合適嘅換電運營商，閱讀同意《換電服務協議》，就可以完成換電帳號嘅創建。",
          "如果您所在嘅地區尚未開通藍鯊智能換電服務，咁就無法訪問「換電服務」功能卡片，亦無法創建換電帳號。"
        ],
        [
          "換電帳號係使用藍鯊智能換電服務嘅唯一身份帳號，如果冇換電帳號，就無法享用換電服務嘅權益。換電帳號可以用來購買換電套餐，進行換電服務，管理換電額度同資產，管理換電記錄同消費等。"
        ]
      ],
      [
        [
          "換電套餐係由各個開展換電服務嘅換電運營商，根據各地換電業務需求，自主進行套餐規則制定、套餐價格制定嘅虛擬權益電子商品。",
          "目前套餐規則支援按用電量計費、按換電次數計費以及無限制換電額度三種計費方式，額度按月分配，費用結算方式可月結、季節、年結。具體可選套餐，以所選運營商嘅實際制定規則為準。",
          "完成換電套餐嘅購買，即可享有換電服務權益，可前往線下門市或經銷商，領取換電服務權益，進而使用換電服務。"
        ],
        [
          "根據目前換電服務規則，如今個月有未使用完嘅額度，進入下個月結算週期時會清零，唔會累積到下個月。請根據實際用電需求，揀選適合日常使用嘅換電套餐。"
        ],
        [
          "換電套餐係虛擬權益嘅電子商品，根據換電使用規則係唔可以退款嘅，建議您評估後再進行購買，避免損失，感謝您嘅理解。"
        ],
        [
          "在您購買換電套餐時，請關注換電套餐嘅續費規則，在滿足續費規則嘅前提下，均係可以續費嘅，續費後換電權益會喺「我的換電」頁面唔斷累積。請您根據實際需要，合理購買同續費。"
        ],
        [
          "換電套餐購買後，次月1日生效。請注意，若需要當即生效，需要勾選「當月生效」選項，並補足當月生效的套餐額度，即可實現換電套餐的當即生效。請在購買換電套餐時，合理地根據個人需要，計劃換電套餐的啟用時間。"
        ]
      ],
      [
        [
          "購買完換電套餐，首先需要根據App的引導，前往線下門市或經銷商網點，領取換電服務權益並登記電池。如果電池為租賃電池，需前往線下門市或經銷商網點，租賃電池並繳納電池租賃押金。",
          "登記後的電池即享有換電服務權益，即可將電池插入換電櫃，換電櫃會自動彈出滿電或者是高電量電池，並將換電服務權益，捆綁至新彈出的電池上。"
        ],
        [
          "用戶完成首次換電電池登記後，後續的每次換電，僅需要將低電量電池插入換電櫃空倉，換電櫃會自動將滿電或者是高電量電池彈出。",
          "若換電櫃未正常彈出電池，根據換電櫃屏幕提示的內容，聯絡人工客服處理。"
        ],
        [
          "您可以選擇Blueshark app嘅換電服務卡片，換電地圖首頁，查詢到附近嘅換電櫃資訊，包括換電櫃嘅名稱、位置、距離您嘅距離、電池情況嘅概覽等，點擊換電櫃，進入換電櫃詳情頁，即可查看所選換電櫃嘅電池資訊情況。"
        ],
        [
          "導致換電失敗嘅原因，可能有以下幾種情況：",
          "①插入嘅電池換電服務已到期，導致無法正常換電，請先續費後再使用；",
          "②換電櫃內無可換電池，即換電櫃內嘅電池電量都唔符合換電條件，導致無法換電，可以前往其他換電櫃進行換電；",
          "③如果以上情況都正常，多次嘗試換電都無法成功時，請聯絡人工客戶服務解決。"
        ]
      ]
    ],
    quickGuide: "車輛快速上手指南",
    quickGuideList: [
      "基本操作",
      "車輛激活",
      "駐車功能",
      "行車功能",
      "騎行與擋位"
    ],
    QuickListSubtitle: [
      ["H1 2023基本操作", "R1 2023基本操作"],
      ["H1 2023車輛激活", "R1 2023車輛激活"],
      ["H1 2023駐車功能", "R1 2023駐車功能"],
      ["H1 2023行車功能", "R1 2023行車功能"],
      ["H1 2023騎行與擋位", "R1 2023騎行與擋位"]
    ],
    h1Node:
      "註：本指南僅適用 H1 2023，H1 lite請參照說明書使用，本指南內容僅支持快速上手使用，詳細的操作請參見說明書。",
    r1Node:
      "註：本指南僅適用 R1 2023，R1 lite請參照說明書使用，本指南內容僅支持快速上手使用，詳細的操作請參見說明書。",
    lightDescription: "指示燈說明",
    signalLeft: "左轉向燈",
    signalRight: "右轉向燈",
    highBeam: "遠光燈",
    lowBeam: "近光燈",
    lowPowerLight: "低電量提示燈",
    faultLight: "故障提示燈",
    readyLight: "準備狀態指示燈",
    instrumentPic: "儀錶平面示意圖",
    leftKeyDescription: "按鍵說明（左手把）",
    leftHandPic: "左手把示意圖",
    rightKeyDescription: "按鍵說明（右手把）",
    rightHandPic: "右手把示意圖",
    overtakingLightKey: "超車燈鍵：拨动灯光会闪烁",
    lowBeanKey: "近光燈鍵：拨动开启近光灯",
    highBeamKey: "遠光燈鍵：拨动开启远光灯",
    configKey: "確認鍵：用於多功能卡片內的確認操作",
    smartKey: "智能鍵：用於多功能卡片內的切換及卡片的控制",
    LeftTrunSignalKey: "轉向燈鍵：向左拨動開啟左轉向燈，向中間按壓關閉轉向燈",
    RightTrunSignalKey: "轉向燈鍵：向右拨動開啟右轉向燈，向中間按壓關閉轉向燈",
    hornKey: "喇叭鍵：用手按住鳴笛，放開鳴笛結束",
    cruiseControlKey:
      "定速巡航鍵：短按開啟定速巡航（車速大於15公里/小時），再次短按或踩刹車關閉定速巡航",
    waringKey: "危險警示燈鍵：當車輛出現故障或發生緊急狀況時，按下開啟雙閃",
    costomKey: "自訂按鍵：待更新",
    turboKey: "TURBO鍵：短按進入TURBO擋，再次短按退出TURBO擋",
    sportKey: "SPORT鍵：短按進入SPORT擋，再次短按退出SPORT擋",
    openSeatKey: "開坐桶鍵：車輛通電狀態下，短按開啟坐桶",
    transferAssistanceKey:
      "移車助力鍵：當車輛處於騎行狀態且靜止時，短按 MAM 鍵進入移車助力擋位，此時拨動「M」或轉動轉把可操作車輛前後緩速移動。",
    gearKey: "擋位鍵：短按切換擋位",
    LeftGearKey: "擋位键：向左拨动降擋",
    RightGearKey: "擋位键：向右拨动升擋",
    volumeIncreaseKey: "音量調節鍵：短按右側鍵增加音量",
    volumedecreaseKey: "音量調節键：短按左侧键降低音量",
    readyKey: "Ready鍵：短按即可切換行車或駐車模式",
    activationNode:
      "注：新車交付時，車輛屬於未啟用狀態，需要啟用後使用完整的功能及服務",
    activeCardPic: "車輛啟動卡片圖示",
    activeUIPic: "車輛啟動界面圖示",
    activeStep1: "第一步：首次開機頁面",
    activeStep2: "第二步：App下載引導頁",
    activeStep3: "第三步：啟動頁操作引導頁",
    activeStep4: "第四步：啟動結果頁",
    activeStepInfo1: "當車輛出現此卡片時，短按",
    activeStepInfo2: "進入啟動的流程",
    activeStepInfo3: "可以在安卓/蘋果市場下載App；如已經下載，可以直接短按",
    activeStepInfo5: "切換下一步",
    activeStepInfo6:
      "根據App提示搜索車輛，找到對應車輛後，輸入車輛儀表上顯示的4位PIN碼完成啟動",
    activeStepInfo7:
      "激活成功後跳轉至激活成功頁面（請注意，必須在5分鐘內完成此操作，否則激活流程將重新開始。）",
    instrumentDescription: "儀表整體說明",
    instrumentStopPic: "儀錶（駐車狀態）示意圖 ",
    instrumentWorkPic: "儀表（行車狀態）示意圖",
    cardPic: "聚合卡片圖示",
    instrumentInfo1:
      "智能卡片區（包含聚合卡片、騎行統計、藍牙音樂、藍牙設置、車輛健康、車輛設置）",
    instrumentInfo2: "中間資訊區（包含車輛健康狀態、車輛行駛統計）",
    instrumentInfo3: "車輛信息區（包含車輛模式、續航信息、功能啟用狀態）",
    aggregatedCardArea: "智能卡片區-聚合卡片",
    aggregatedCardInfo1:
      "顯示藍牙音樂的播放狀態，可以根據音樂功能內的提示文案判斷音樂功能的狀態",
    aggregatedCardInfo2:
      "顯示藍牙的連接狀態，未連接時，圖標顏色為灰色，連接成功時，圖標顏色為彩色",
    aggregatedCardInfo3:
      "顯示行車記錄儀的開閉狀態，未開啟時，圖標顏色為灰色，開啟時，圖標顏色為彩色",
    aggregatedCardInfo4: "功能暫未開放，敬請期待",
    cyclingStatistics: "智能卡片區-騎行統計",
    cyclingPic: "騎行統計圖示",
    cyclingStatisticsInfo1: "此處顯示了車輛的總行駛里程，自出廠開始統計",
    cyclingStatisticsInfo2: "此處顯示了您某一次的行駛里程，可以短按",
    cyclingStatisticsInfo3: "重置此數據",
    BluetoothMusic: "智能卡片區-藍牙音樂",
    BluetoothPic: "藍牙音樂圖示",
    BluetoothMusicInfo1:
      "有音訊時此處顯示歌手及歌詞的名稱，無音訊時此處顯示【未知歌曲】（需要連接藍牙後通過移動設備播放音訊）",
    BluetoothMusicInfo2: "短按",
    BluetoothMusicInfo3: "控制播放音樂/暫停音樂",
    BluetoothMusicInfo4: "長按",
    BluetoothMusicInfo5: "切換下一曲",
    vehicleHealth: "智能卡片區-車輛健康",
    healthPic: "車輛健康圖示",
    warningPic: "車輛異常圖示",
    vehicleHealthInfo1:
      "啟動車輛後，切換至此卡片，它會自動對車輛健康狀況進行檢測",
    vehicleHealthInfo2:
      "當車輛健康狀況出現問題時，卡片內會顯示相應的故障資訊，可以通過短按",
    vehicleHealthInfo3: "鍵查看故障的詳細資訊",
    vehicleSetting: "智能卡片區-車輛設置",
    settingPic: "車輛設定圖示",
    vehicleSettingInfo1:
      "此功能可以針對車輛進行設置（包含的設置項：藍牙音量、摩托音、顯示模式、車輛版本、語言設置、行車記錄儀、恢復出廠設置、安全輔助、待綁定模式、距離單位、時間單位）",
    vehicleSettingInfo2: "想要切換不同的功能時，可以短按",
    vehicleSettingInfo3: "來控制",
    vehicleSettingInfo4: "找到自己需要的功能想要確認時，可以短按",
    vehicleSettingInfo5: "來進行確認",
    instrumentWorkingInfo1: "智能卡片區（包含聚合卡片、騎行統計、藍牙音樂）",
    instrumentWorkingInfo2: "中間信息區（包含車輛實時速度、電池信息）",
    instrumentWorkingInfo3:
      "車輛信息區（包含車輛模式、續航信息、實時電流、實時能耗）",
    aggregatedCardWorkingInfo2: "顯示本次騎行數據",
    startCycling: "開始騎行",
    startInfo:
      "短按【Ready】鍵，進入或退出騎行模式，儀表顯示對應畫面（詳見下圖）",
    gearShift: "擋位切換",
    gearNote:
      "注：车辆一共有五个擋位，分别是【ECO】【COMFORT】【SPORT】【TURBO】【MAM】",
    H1GearNote:
      "註：車輛共有四個模式，分別是【ECO】【COMFORT】【SPORT】【MAM】",
    gearInfo1: "ECO模式適合節能駕駛，可以提供最長的續航",
    gearInfo2: "COMFORT 擋位適合日常駕駛時使用，平衡續航、加速和極速",
    gearInfo3: "SPORT 擋位適合運動駕駛時使用，突出超車性能、極速性能",
    gearInfo4: "TURBO 擋位適合激烈駕駛時使用，釋放車輛所有性能",
    gearInfo5: "MAM 擋位適合推車/挪車時使用",
    gearInfo6: "向左或向右拨动M键进行切换擋位",
    gearInfo7: "短按Turbo鍵進入Turbo擋",
    gearInfo8:
      "長按此按鍵進入MAM擋，此時可以拧動轉把或拨動M-/M+來控制車輛移動（M-倒車；M+前進）",
    gearInfo9: "按M键进行切换擋位",
    gearInfo10:
      "長按此按鍵進入MAM模式，此時可以按下M-/M+來控制車輛移動（M-倒車；M+前進）",
    drivingPage: "行車頁面",
    parkingPage: "駐車頁面",
    gearPic: "擋位信息顯示區域圖",
    questions,
    troubles
  }
};

export default tw;



// WEBPACK FOOTER //
// ./src/i18n/langs/tw.js